import angular from 'angular';
import uibModal from 'angular-ui-bootstrap/src/modal';
export default angular.module('media.picker.modal', [uibModal]).service('MediaPickerModal', function($uibModal) {

    this.open = (multiple = false) => {

        return $uibModal.open({
            animation: true,
            template: require('./media-picker-modal.html'),
            size: 'lg',
            windowClass: 'media-picker-modal',
            resolve: {
                multiple: () => {
                    return multiple;
                }
            },
            controllerAs: '$ctrl',
            controller: function($scope, CONFIG, MediaResource, UnsplashResource, multiple, gettextCatalog) {
                /** @ngInject */

                this.multiple = multiple;
                this.selectedMedia = [];
                this.showSpinner = false;

                this.activeTab = 1;

                this.setActiveTab = (number) => {
                    this.activeTab = number;
                }

                this.onMediaSelected = (media, selected) => {
                    if(this.multiple) {
                        if (selected) {
                            this.selectedMedia.push(media);
                        } else {
                            this.selectedMedia = this.selectedMedia.filter(function (selectedElement) {
                                return selectedElement.id !== media.id;
                            });
                        }
                    } else {
                        this.selectedMedia = selected ? [media] : [];
                    }
                };

                this.selectedMediaString = () => {
                    return this.selectedMedia.map(el => {
                        if(this.isUnsplashElement(el)) {
                            return gettextCatalog.getString("Photo by {{user}} from {{source}}", {
                                user: el.user.name,
                                source: 'Unsplash'
                            });
                        } else {
                            return el.clientOriginalName;
                        }}).join(", ");
                };

                this.isUnsplashElement = (el) => {
                    return !el.key && (el.id && el.links && el.urls);
                };

                this.close = async (selectedMedia) => {
                    this.pending = true;
                    for(let i = 0; i < selectedMedia.length; i++) {
                        if(this.isUnsplashElement(selectedMedia[i])) {
                            selectedMedia[i] = await UnsplashResource.get({id: selectedMedia[i].id}).$promise;
                        }
                        this.removeUnnecessaryKeysFromSelectedMedia(selectedMedia[i]);
                    }
                    this.pending = false;
                    $scope.$close(selectedMedia);
                };

                this.removeUnnecessaryKeysFromSelectedMedia = (selectedMedia) => {
                    Object.keys(selectedMedia).forEach(key => {
                        if(['key', 'id', 'type', 'size', 'clientOriginalName'].indexOf(key) === -1){
                            delete selectedMedia[key];
                        }
                    });

                }
            }
        })
    }

}).name;





// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaPickerModal/MediaPickerModal.js